import React from 'react'

import { useTranslation } from 'react-i18n-lite'

import { NavigationSlider, useIsMobile } from '@yes.technology/react-toolkit'

import { useSiteState } from 'siteState/shared'

import { FilterFieldsDisplayOptions } from '../../FilterFields'

import {
  CenterWrapper,
  FirstElement,
  StyledCardWithAreaLine,
  StyledCollapsibleCard
} from './GroupControls.styles'

export type GroupControlsProp = {
  elementUuid: string
  sectionPosition: number
  sectionsLength: number
  setSectionPosition: (section: number) => void
  groupPosition: number
  groupsLength: number
  setGroupPosition: (group: number) => void
  handleClearCurrentGroup: () => void
  navigationSliderBackgroundColor?: string
  navigationSliderColor?: string
  children: React.ReactNode
  shouldHideFilters: boolean
}

export default function GroupControls({
  sectionsLength,
  sectionPosition,
  setSectionPosition,
  navigationSliderBackgroundColor,
  navigationSliderColor,
  children,
  shouldHideFilters,
  elementUuid
}: GroupControlsProp) {
  const { t } = useTranslation()

  const isMobile = useIsMobile()

  const areaLineTitle = (
    <FirstElement color={navigationSliderColor}>
      {t('report.filter-area.filter-head.filter-group')}
    </FirstElement>
  )

  const leftHeaderElement = isMobile ? undefined : areaLineTitle

  const centerHeaderElement = shouldHideFilters ? (
    isMobile ? (
      areaLineTitle
    ) : undefined
  ) : (
    <CenterWrapper>
      <NavigationSlider
        heightClass='small'
        currentPosition={sectionPosition}
        first={1}
        total={sectionsLength}
        afterClick={setSectionPosition}
        textForCurrent={t('filter-fields.section')}
        hierarchyLevel='level_3'
        backgroundColor={navigationSliderBackgroundColor}
        color={navigationSliderColor}
      />
    </CenterWrapper>
  )

  const rightHeaderElement = isMobile || shouldHideFilters ? undefined : <></>

  const CardComponent = shouldHideFilters
    ? StyledCardWithAreaLine
    : StyledCollapsibleCard

  const [displayOptions] = useSiteState<FilterFieldsDisplayOptions>(
    'filter-display-options'
  )

  const displayOptionsElement = displayOptions?.[elementUuid]

  if (displayOptionsElement?.hideFieldsCollapsibleContainer)
    return <>{children}</>

  return (
    <CardComponent
      data-testid='group-controls'
      leftHeaderElement={leftHeaderElement}
      centerHeaderElement={centerHeaderElement}
      rightHeaderElement={rightHeaderElement}
      heightClass='xSmall'
      headerColor='blue'
      alignSecondPosition='center'
      backgroundColor={navigationSliderBackgroundColor}
      color={navigationSliderColor}
      {...(!shouldHideFilters && {
        defaultOpenState: true
      })}
    >
      {children}
    </CardComponent>
  )
}
